import { render, staticRenderFns } from "./_IPOCode.vue?vue&type=template&id=45d1ed6c&scoped=true"
import script from "./_IPOCode.vue?vue&type=script&lang=js"
export * from "./_IPOCode.vue?vue&type=script&lang=js"
import style0 from "./_IPOCode.vue?vue&type=style&index=0&id=45d1ed6c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1ed6c",
  null
  
)

/* custom blocks */
import block0 from "./locale/ipo-details-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fipo-subscriptions%2F_IPOCode.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/ipo-details-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fipo-subscriptions%2F_IPOCode.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingAnimation: require('/vercel/path0/components/ui/LoadingAnimation.vue').default,ClampLines: require('/vercel/path0/components/ui/ClampLines.vue').default,TwoColumnBlock: require('/vercel/path0/components/blocks/TwoColumnBlock.vue').default,VideoThumbnailCard: require('/vercel/path0/components/ui/VideoThumbnailCard.vue').default,AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,IvestorAppStoreLinks: require('/vercel/path0/components/blocks/ivestorAppStoreLinks.vue').default,HalfMediaHalfGrid: require('/vercel/path0/components/blocks/HalfMediaHalfGrid.vue').default,DownloadCard: require('/vercel/path0/components/DownloadCard.vue').default})
